import { useEffect, useState } from "react";

import debounceFn from "lodash.debounce";
export const isBrowser = typeof window !== "undefined" && window.document;
const isNumber = (c: string) => !Number.isNaN(Number.parseInt(c));
export const usePlacesAutocomplete = (debounce: number) => {
	const [placeInputValue, setPlaceInputValue] = useState(null);
	const [placePredictions, setPlacePredictions] = useState<DogsTrust.Place[]>(
		[],
	);
	const [isPlacePredsLoading, setIsPlacePredsLoading] = useState(false);

	useEffect(() => {
		const getPlacesDebounced = debounceFn(async () => {
			let res: { result: DogsTrust.PlaceResult[] };
			let places = [];
			if (
				placeInputValue?.length >= 2 &&
				!isNumber(placeInputValue[0]) &&
				(isNumber(placeInputValue[1]) || isNumber(placeInputValue[2]))
			) {
				res = await fetch(
					`${process.env.GATSBY_AWS_PLACES_ENDPOINT}postcodes/?q=${placeInputValue}`,
				).then((res) => res.json());
				places = res.result.map((place: DogsTrust.PlaceResult) => ({
					address: [place.outcode, place.incode]
						.filter((place) => !!place)
						.join(" "),
					latitude: place.latitude,
					longitude: place.longitude,
				}));
			} else {
				res = await fetch(
					`${process.env.GATSBY_AWS_PLACES_ENDPOINT}places/?q=${placeInputValue}`,
				).then((res) => res.json());
				places = res.result.map((place: DogsTrust.PlaceResult) => ({
					address: [place.name_1, place.county_unitary, place.outcode]
						.filter((place) => !!place)
						.join(", "),
					latitude: place.latitude,
					longitude: place.longitude,
				}));
			}

			setPlacePredictions(places || []);
		}, debounce);

		getPlacesDebounced();
		return () => getPlacesDebounced.cancel();
	}, [placeInputValue, debounce]);

	const getPlacePredictions = (input: string) => {
		if (input) {
			setPlaceInputValue(input);
			setIsPlacePredsLoading(true);
			return;
		}
		setPlacePredictions([]);
		setPlaceInputValue(null);
		setIsPlacePredsLoading(false);
	};
	return {
		placePredictions: placeInputValue ? placePredictions : [],
		isPlacePredictionsLoading: isPlacePredsLoading,
		getPlacePredictions,
	};
};
